import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Evite from './components/Evite';
import RSVPForm from './components/RSVPForm';
import Confirmation from './components/Confirmation';
import './App.css';

function AnimatedRoutes({ rsvpData, setRsvpData }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<Evite />} />
        <Route
          path="/rsvp"
          element={<RSVPForm onSubmit={setRsvpData} />}
        />
        <Route
          path="/confirmation"
          element={
            rsvpData ? (
              <Confirmation data={rsvpData} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  const [rsvpData, setRsvpData] = useState(null);

  return (
    <Router>
      <div className="App">
        <AnimatedRoutes rsvpData={rsvpData} setRsvpData={setRsvpData} />
      </div>
    </Router>
  );
}

export default App;
